import { render, staticRenderFns } from "./ViewTaskLoader.vue?vue&type=template&id=89544524&"
import script from "./ViewTaskLoader.vue?vue&type=script&lang=js&"
export * from "./ViewTaskLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports